<template>
  <div class="page-container md-layout-column">
    <menu-bar></menu-bar>
    <md-content class="TL_BookSession">
        <router-view
            class="Page">
        </router-view>
    </md-content>
  </div>
</template>

<script>
  import "./sass/main.scss";

  export default {
    name: 'App',
    components: {},
    methods: {},
    data: () => ({}),
  };
</script>
